export default {
    serotype_1: 'DEN1',
    serotype_2: 'DEN2',
    serotype_3: 'DEN3',
    serotype_4: 'DEN4',
};
